export default "__VITE_ASSET__SQOe5wpy__"